import { Component } from '@angular/core';

import { environment } from '../environments/environment'
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
    get isLoading() {
        return this.spinnerService.isLoading;
    }

    constructor(
        private spinnerService: SpinnerService
    ) {
        if (environment.production) {
            window.console.log = function () {
            };
            window.console.error = function () {
            };
        }
    }
}
